module.exports = __webpack_public_path__ + "static/media/Applift_MissionDetails.24e0a800.png";